import { ExclamationCircleOutlined } from '@ant-design/icons';
import React from 'react';
import { useTranslation } from 'react-i18next';

const StatusChip = ({ status }) => {
  const { t } = useTranslation();

  // Configure the chip based on status
  const getChipConfig = () => {
    switch (status) {
      case 'SUBMITTED':
        return {
          className: 'status-chip status-submitted',
          textClassName: 'status-chip-text status-submitted-text',
          text: t('sidebar.submitted'),
          icon: null
        };
      case 'PENDING':
        return {
          className: 'status-chip status-pending',
          textClassName: 'status-chip-text status-pending-text',
          text: t('sidebar.pending'),
          icon: null
        };
      case 'ERROR':
        return {
          className: 'status-chip status-error',
          textClassName: 'status-chip-text status-error-text',
          text: t('sidebar.error'),
          icon: 'error',
          iconClassName: 'icon-small icon-error'
        };
      case 'RED_NOTE':
        return {
          className: 'status-chip status-red-note',
          textClassName: 'status-chip-text status-red-note-text',
          text: t('sidebar.redNote'),
          icon: null
        };
      default:
        return {
          className: 'status-chip',
          textClassName: 'status-chip-text',
          text: status,
          icon: null
        };
    }
  };

  const config = getChipConfig();

  return (
    <div className={config.className} style={{ cursor: 'default' }}>
      {config.icon && (
        <div className="icon">
          <ExclamationCircleOutlined className="icon-small icon-error" />
        </div>
      )}
      <div className={config.textClassName}>{config.text}</div>
    </div>
  );
};

export default StatusChip; 